/**
 * Determines whether a url is a deep link
 * @param {string} url
 * @returns {boolean}
 * */
function isDeepLink(url: string): boolean {
  return url.startsWith('number26://')
}

/**
 * Determines whether a link is an external link
 * @param {string} [url='']
 * @returns {boolean}
 * */
function isLinkExternal(url = ''): boolean {
  // If the url we get is in the form of {pathname: 'somewhere'} it must be an
  // internal link.
  if (typeof url !== 'string') return false

  // Mailto URLs are external.
  if (url.startsWith('mailto')) return true

  // Tel URLs are external.
  if (url.startsWith('tel')) return true

  // Deep links that lead to the native app should be handled like external
  // links.
  return /^https?:\/\//.test(url) || isDeepLink(url)
}

export { isLinkExternal }
